import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('drawControls');

    return {
        SAVE: t('save')
    };
};

export default useTranslation;
